import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkoutModel } from 'src/app/configuration/training/models/exercise.model';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardModule } from '@angular/material/card';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatLabel } from '@angular/material/form-field';


@Component({
    selector: 'app-display-workout-card',
    templateUrl: './display-workout-card.component.html',
    styleUrls: ['./display-workout-card.component.css'],
  imports: [
    MatCardModule,
    MatIconModule,
    MatLabel
]
})
export class DisplayWorkoutCardComponent implements OnInit {

  @Input() Workout: WorkoutModel;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  statuscardcolor(status: string): string{
    switch(status){
      case "DRAFT":
        return "#686868";
      case "ACTIVE":
        return "green";
      case "ARCHIVED":
        return "red";
    }
  }


}
